import { IElementHistory } from "core-integration/src/store/elements/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { Badge } from "plos/src/components/Badge";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AccessibleFixtureText } from "../../../../../AccessibleFixtureText";
import {
  badgeContainer,
  matchChip,
  matchListItem,
  matchRound,
  matchUnit,
  teamContainer,
  teamName,
} from "../styles.css";

const HistoryItem = ({ history }: { history: IElementHistory }) => {
  const { t } = useTranslation();
  const teamsById = useSelector(getTeamsById);
  const opponentTeam = teamsById[history.opponent_team];
  const { short_name, name } = opponentTeam;
  const { round, total_points: totalPoints, was_home } = history;

  return (
    <li className={matchListItem}>
      <div className={matchUnit}>
        <span
          aria-label={
            t("historyItem.gameweek.name", "Gameweek {{round}}", {
              round,
            }) as string
          }
          className={matchRound}
        >
          {
            t("historyItem.gameweek.shortName", "GW{{round}}", {
              round,
            }) as string
          }
        </span>
        <span className={teamContainer}>
          <div className={badgeContainer}>
            <Badge team={opponentTeam} isPresentation />
          </div>
          <span className={teamName} aria-hidden="true">
            {short_name}
          </span>
          <AccessibleFixtureText name={name} isHome={was_home} />
        </span>
        <span
          aria-label={
            t("historyItem.points.name", "{{totalPoints}} points", {
              totalPoints,
            }) as string
          }
          className={matchChip.default}
          dir="ltr"
        >
          {
            t("historyItem.points.shortName", "{{totalPoints}}pts", {
              totalPoints,
            }) as string
          }
        </span>
      </div>
    </li>
  );
};

export default HistoryItem;
